import { NgModule } from '@angular/core'
import { EmailStatusFilterPipe } from './email-status-filter.pipe'
import { EmailTypeFilterPipe } from './email-type-filter.pipe';

import { StepTypePipe } from './steps/step-type.pipe';

import { StatusPipe as ProjectStatusPipe } from './projects/status.pipe';
import { StatusPipe as StepStatusPipe } from './steps/status.pipe';
import { StatusPipe as TaskStatusPipe } from './tasks/status.pipe';
import { BadgesTextColourPipe } from './badges-text-colour.pipe';
import { StatusPipe as PaymentStatusPipe } from './payments/status.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { StatusPipe as TimeAndBillingStatusPipe } from './time_and_billing/status.pipe';

@NgModule({
    declarations: [EmailStatusFilterPipe, EmailTypeFilterPipe, ProjectStatusPipe, StepTypePipe, StepStatusPipe, TaskStatusPipe, BadgesTextColourPipe, PaymentStatusPipe, SafeHtmlPipe, TimeAndBillingStatusPipe],
    imports: [],
    exports: [EmailStatusFilterPipe, EmailTypeFilterPipe, ProjectStatusPipe, StepTypePipe, StepStatusPipe, TaskStatusPipe, BadgesTextColourPipe, PaymentStatusPipe, SafeHtmlPipe,TimeAndBillingStatusPipe],
})
export class PipesModule { }
